import {Image} from '@/_application/core/components/ui/image';
import cn from 'classnames';
import {productPlaceholder} from '@/lib/placeholders';
import Link from '@/_application/core/components/ui/link';
import {CategoryTree} from '__generated__/__types__';
import {getCategoryUrl} from '@/_application/modules/categories/models/url';

interface IProps {
    category: CategoryTree;
    isHover: boolean;
    isHeader: boolean;
    onSelectCategory: (category: CategoryTree) => void;
}

function SidebarCategoryItem({category, isHover, isHeader, onSelectCategory}: Readonly<IProps>) {
    const sourceImage = category.featured_icon
        ? 'https://cdn-v2.kidsplaza.vn/' + category.featured_icon
        : productPlaceholder;

    return (
        <Link href={getCategoryUrl(category)} passHref className="font-normal">
            <button
                aria-label="Mục danh mục thanh bên"
                className={cn('flex w-full items-center gap-2 ', {
                    'px-[22px]': !isHeader,
                    'px-4': isHeader,
                })}
                onMouseEnter={() => onSelectCategory(category)}>
                <div className="relative h-4 w-4">
                    <Image src={sourceImage} alt="category icon" fill />
                </div>
                <p className={cn('cursor-pointer text-KPZ_text_1st truncate', {'font-bold text-primary': isHover})}>
                    {category.name}
                </p>
            </button>
        </Link>
    );
}

export default SidebarCategoryItem;
